export default "__VITE_ASSET__wCzVN1B5__"